import { Trans } from '@lingui/react/macro';
import { isPresent } from '@luminovo/commons';
import { colorSystem, Flexbox, Text, Tooltip } from '@luminovo/design-system';
import { styled, TableCell } from '@mui/material';
import { TextAlignStartIcon } from 'lucide-react';
import type { JSX } from 'react';

const ClickableCell = styled(TableCell)({
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    verticalAlign: 'center',
});

const NotesBadge = styled('span')({
    display: 'flex',
    border: `1px solid ${colorSystem.neutral[2]}`,
    borderRadius: '24px',
    padding: '2px 8px',
});

export const NotesCell = ({ notes }: { notes?: string }): JSX.Element => {
    if (!Boolean(notes) || !isPresent(notes)) {
        return <ClickableCell />;
    }

    return (
        <ClickableCell>
            <Flexbox
                sx={{
                    justifyContent: 'center',
                }}
            >
                <Tooltip
                    variant={'white'}
                    title={
                        <Flexbox
                            gap={4}
                            sx={{
                                flexDirection: 'column',
                                padding: '4px',
                            }}
                        >
                            <Text variant="h5" color={colorSystem.neutral[8]}>
                                <Trans>Notes</Trans>
                            </Text>
                            <Text variant="body-small" color={colorSystem.neutral[8]}>
                                {notes}
                            </Text>
                        </Flexbox>
                    }
                >
                    <NotesBadge>
                        <TextAlignStartIcon size={16} color={colorSystem.neutral[6]} />
                    </NotesBadge>
                </Tooltip>
            </Flexbox>
        </ClickableCell>
    );
};
